'use client';

import React from 'react';
import isEmpty from 'lodash/isEmpty';
import type { Instance } from '@popperjs/core';
import { createPopper } from '@popperjs/core';

const getNodes = (selector: string): Element[] =>
  Array.prototype.slice.call(document.querySelectorAll(selector));

const isNumber = (item: Element) => !isNaN(parseInt(item.textContent ?? ''));
const show = (ref: Element) => ref.setAttribute('data-show', '');
const hide = (ref: Element) => ref.removeAttribute('data-show');

const isMeasurement = (item: Element) => {
  if (item.parentElement) {
    return item.parentElement.textContent?.match(/m[0-9]/g);
  }
};

export const Popper = () => {
  React.useEffect(() => {
    let count = 0;
    const nodes: Instance[] = [];
    const popperInterval = setInterval(() => {
      count++;
      if (
        getNodes('.ParagraphFootnotes__root div > ol > li').length > 0 ||
        count > 10
      ) {
        const superscripted = getNodes('#content sup');
        const footnotes = getNodes(
          '#content .ParagraphFootnotes__root div > ol > li',
        );

        const references = superscripted.filter(
          (sup: Element): boolean => isNumber(sup) && !isMeasurement(sup),
        );

        if (!isEmpty(references)) {
          for (const [index, ref] of references.entries()) {
            if (!document.getElementById('popper-'.concat(String(index + 1)))) {
              const popper = document.createElement('div');
              popper.classList.add('popper-box');
              popper.id = 'popper-'.concat(String(index + 1));
              popper.innerHTML = footnotes[index]?.innerHTML || '';
              const c: Element = ref.insertBefore(popper, null);

              const popperInstance = createPopper(ref, popper, {
                modifiers: [
                  {
                    name: 'preventOverflow',
                    options: {
                      padding: 16,
                    },
                  },
                ],
              });

              if ('addEventListener' in ref) {
                ref.addEventListener('mouseenter', () => {
                  show(c);
                  popperInstance.forceUpdate();
                });

                ref.addEventListener('mouseleave', () => {
                  hide(c);
                  popperInstance.forceUpdate();
                });

                nodes.push(popperInstance);
              }
            }
          }
        }
        clearInterval(popperInterval);
      }

      return () => {
        nodes.map((node: Instance) => node.destroy());
      };
    }, 1500);
  });

  return null;
};
